import { constants } from '../constant/reducerConstant';

export const commonActions = {
  clearErrorPage,
};

function clearErrorPage() {
  return { type: constants.HIDE_ERROR_PAGE };
}
